import { makeAutoObservable } from "mobx";
import { createClient } from "@/core/helpers";
import { ApiClient } from "@/clients/ApiClient";

export class AuthorStore {
    private client: ApiClient;
    author: Author | null = null;
    podcasts: Podcast[] = [];
    loading = false;
    private loadedAuthorSlug: string | null = null;

    constructor() {
        makeAutoObservable(this);
        this.client = createClient();
    }

    public async getAuthorBySlug(slug: string) {
        const { author } = await this.client.get<AuthorResponse>(`/authors/bySlug/${slug}`);
        this.author = author;
        this.podcasts = author.podcasts || [];
    }

    /**
     * Auto-loads author by slug if not already loaded.
     * Safe to call multiple times - only fetches once per slug.
     */
    async ensureAuthorBySlug(slug: string) {
        if (this.author?.slug === slug) {
            return;
        }

        this.loading = true;
        try {
            const { author } = await this.client.get<AuthorResponse>(`/authors/bySlug/${slug}`);
            this.author = author;
            this.podcasts = author.podcasts || [];
            this.loadedAuthorSlug = slug;
        } finally {
            this.loading = false;
        }
    }
}
